const map = {
	"./Accept.svg": 22924,
	"./RiskAlert.svg": 93241,
	"./WhatsApp.svg": 36102,
	"./ai-white.svg": 48794,
	"./ai.svg": 66638,
	"./aigzt.svg": 21243,
	"./bianji.svg": 66905,
	"./biaoge.svg": 73531,
	"./biaoti1.svg": 16255,
	"./biaoti2.svg": 44556,
	"./caidan.svg": 44950,
	"./cancle.svg": 30484,
	"./cha.svg": 15182,
	"./chaodafujian.svg": 12993,
	"./charuqianming.svg": 33473,
	"./cleartabs.svg": 55891,
	"./copy.svg": 61075,
	"./create.svg": 9824,
	"./daily-report-entry.svg": 14129,
	"./daiwoshenpi.svg": 48793,
	"./danju.svg": 69138,
	"./danjuzhuanfujian.svg": 69649,
	"./dayin.svg": 64203,
	"./delete.svg": 77773,
	"./duigou.svg": 81517,
	"./fasong.svg": 59940,
	"./files.svg": 26497,
	"./fujian.svg": 34325,
	"./guding.svg": 29240,
	"./guibingyoujian.svg": 67066,
	"./home1.svg": 4834,
	"./home10.svg": 158,
	"./home11.svg": 79087,
	"./home12.svg": 60,
	"./home2.svg": 85233,
	"./home3.svg": 44672,
	"./home4.svg": 57695,
	"./home5.svg": 19758,
	"./home6.svg": 14125,
	"./home7.svg": 78668,
	"./home8.svg": 93643,
	"./home9.svg": 88378,
	"./houtui.svg": 26166,
	"./huifu.svg": 35717,
	"./huifuquanbu.svg": 59673,
	"./huixingzhen.svg": 85933,
	"./jiacu.svg": 20956,
	"./jinjiyoujian.svg": 19391,
	"./khgj.svg": 78114,
	"./lianjie.svg": 26568,
	"./mail.svg": 40809,
	"./mail_read.svg": 72848,
	"./mail_unread.svg": 41025,
	"./more.svg": 43639,
	"./neifenfa.svg": 53364,
	"./neifenfabiaoji.svg": 39428,
	"./nichengtidai.svg": 84535,
	"./phone.svg": 14704,
	"./qianjin.svg": 87810,
	"./qingkong.svg": 95800,
	"./quancha.svg": 62243,
	"./quangou.svg": 96618,
	"./quanjia.svg": 81137,
	"./quanjian.svg": 38261,
	"./refresh.svg": 67853,
	"./rich_houtui.svg": 91439,
	"./rich_qianjin.svg": 2117,
	"./rili.svg": 45334,
	"./sandian.svg": 29962,
	"./save.svg": 10475,
	"./send.svg": 31110,
	"./setting.svg": 57008,
	"./shaixuan.svg": 41527,
	"./shanchuxian.svg": 9022,
	"./shandang.svg": 71872,
	"./shenpitongguo.svg": 37918,
	"./shenpituihui.svg": 94741,
	"./shizhong.svg": 74318,
	"./shoucangyoujian.svg": 45079,
	"./shuaxin.svg": 70156,
	"./sikao.svg": 76763,
	"./stop.svg": 88220,
	"./switch.svg": 37920,
	"./task-management.svg": 38957,
	"./test.svg": 72176,
	"./tupian.svg": 33017,
	"./user.svg": 11077,
	"./weidu.svg": 68068,
	"./wenbenmuban.svg": 92094,
	"./wenhao.svg": 85806,
	"./woyaoshenpi.svg": 56926,
	"./wuxu.svg": 65585,
	"./xia.svg": 85342,
	"./xiahuaxian.svg": 91288,
	"./xiaoxizhongxin.svg": 24629,
	"./xieti.svg": 14039,
	"./xmkb.svg": 49218,
	"./yidong.svg": 91068,
	"./yidu.svg": 14455,
	"./you-chao.svg": 83899,
	"./you-fa.svg": 68457,
	"./you-shou.svg": 28579,
	"./you-zhu.svg": 97337,
	"./you.svg": 71253,
	"./youxu.svg": 59240,
	"./youyou.svg": 62346,
	"./zhengwen.svg": 33220,
	"./zhishikuwenjian.svg": 70905,
	"./zhuanfa.svg": 47813,
	"./zuida.svg": 46937,
	"./zuixiao.svg": 97485,
	"./zuo.svg": 27970
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65779;